"use client";

import React, { useState } from 'react';
import { Header, Hero, AboutUs, Products, ContactUs, Footer, ScrollToTop } from './(components)';
import './styles/globals.css';

const Landing: React.FC<{ params: { lng: string } }> = ({ params }) => {
  const { lng } = params;
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({
    "omto-dktb": false,
    "intelligent-modules": false,
  });

  const activateCheckbox = (key: string) => {
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="landing-page bg-omto-gray font-montserrat">
      <Header lng={lng} />
      <Hero 
        lng={lng}
      />
      
      <AboutUs lng={lng} />
      
      <Products lng={lng} activateCheckbox={activateCheckbox} checkedItems={checkedItems} />
      
      <ContactUs lng={lng} activateCheckbox={activateCheckbox} checkedItems={checkedItems} />
      <Footer lng={lng} />
      <ScrollToTop />
    </div>
  );
};

export default Landing;
